import { createMetricSender } from '@/src/metrics/send-metric';
import { getVendorRankType } from '@/src/utils/rankType/getVendorRankType';
import {
  DEFAULT_ORIGIN_RESTAURANTS,
  restaurants as trackingRestaurants,
} from '@/src/utils/tracking/restaurants/restaurants';
import { VendorItemProps } from '@components/VendorItem/VendorItem.types';
import VendorItem from '@pedidosya/web-fenix/businessComponents/VendorItem';
import { useState } from 'react';
import styled from 'styled-components';

const WrapperVendorItem = styled.div`
  .StyledCardLandscape {
    border: none;
    padding-left: 0;
    [data-testid='fallback-logo'] {
      box-sizing: border-box;
    }
  }
  & > *:first-child {
    padding-left: 0;
  }
  hr {
    height: 0;
  }
  padding-left: 16px;
`;

const showCardPropsMapper = (props: VendorItemProps): VendorItemProps => {
  const country = props && props?.location && props?.location?.country;
  const newProps = { ...props, currencySymbol: country?.currencySymbol };
  if (!props.paymentMethods) {
    newProps.paymentMethods = [];
  }
  return newProps;
};

export const VendorItemCard = (props: VendorItemProps) => {
  const metricSender = createMetricSender();
  const newProps = showCardPropsMapper(props);
  const [lastVendorClicked, setLastVendorClicked] = useState(undefined);
  const { vendor, onClick } = props;
  return (
    <WrapperVendorItem
      data-testid='vendor-click'
      onClick={() => {
        metricSender.onVendorRestaurantClicked();
        setLastVendorClicked(vendor?.vendorId);
        if (lastVendorClicked !== vendor?.vendorId) {
          const { location } = props;
          trackingRestaurants({
            type: 'shop.clicked',
            payload: {
              shopId: vendor?.vendorId,
              filterValue: location?.searchedLocation?.filterValue,
              screenType: DEFAULT_ORIGIN_RESTAURANTS,
              shopGoldVip: vendor?.isPromoted,
              ncrRequestToken: vendor?.ncrToken,
              shopSponsoring: getVendorRankType(vendor?.rankType),
              midasRequestId: vendor?.midasRequestId,
              shopSponsoringPlacement: 'shop_list:swimlane',
              currencyCode: location?.country?.currencyIsoCode,
              shopRatingQuantity: vendor?.rating?.surveyCount,
              shopRatingQuality: vendor?.rating?.score,
              shopName: vendor?.name,
              shopDeliveryFee: vendor?.delivery?.price?.deliveryFeeTotal,
              shopDeliveryTime: vendor?.delivery?.bucket?.label,
              position: vendor?.rank,
              shopListBusinessType: 'Restaurants',
              shopDistance: vendor?.delivery?.distance,
              shopClickOrigin: 'swimlane',
              clickLocation: 'infocard',
              discount: vendor?.labels?.discountLabel,
              productsDecorated: vendor?.productsDecorated,
              screenName: 'promotions-section-restaurants'
            },
          });
        }
        onClick();
      }}
    >
      <VendorItem {...newProps} id='vendor-item' />
    </WrapperVendorItem>
  );
};
